export default "__VITE_ASSET__Cg5Evlt5__"